import ServiceCRUD from '../../../../../services/ServiceGasOrder';

class ProductService extends ServiceCRUD {
  constructor() {
    super(`/api/produtos`);
  }
}

export default new ProductService();
